<template>
  <div>
    <b-button
      size="sm"
      class="ml-2"
      variant="outline-success"
      @click="$emit('showDialog')"
      :disabled="disabled"
    >
      <b-icon-plus></b-icon-plus>
      {{ $l('INDEX.btn_add') || '添加' }}
    </b-button>
    <b-button
      size="sm"
      class="ml-2"
      variant="outline-danger"
      @click="$emit('batchDel')"
      v-if="allow('D')"
      :disabled="disabled"
    >
      <i class="el-icon-delete"></i>{{ $l('INDEX.btn_delete') || '删除' }}
    </b-button>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
}
</script>
